export const INVOKE_EAGRID_BULK_ACTION_EVENT = 'invoke_eag_grid_bulk_action_event';

export type InvokeDatagridBulkActionTarget = {
  actionKey: string;
  rowIds: string[];
};

export type InvokeEagridBulkActionCustomEvent = {
  gridCode: string;
  target: InvokeDatagridBulkActionTarget;
};

declare global {
  interface WindowEventMap {
    [INVOKE_EAGRID_BULK_ACTION_EVENT]: CustomEvent<InvokeEagridBulkActionCustomEvent>;
  }
}

/**
 * Invokes a bulk action on a mounted EagGrid from outside the grid (same channel
 * pattern as selectDatagridRows / refreshDatagrid). Fire-and-forget broadcast: every
 * mounted grid with this gridCode reacts, but rowIds are page-scoped so a sibling grid
 * with different rows resolves to no matching rows. The action runs through the grid's
 * own actionCallback with the given rowIds (see useExternalBulkActionInvocation).
 */
export const invokeDatagridBulkAction = (
  gridCode: string,
  target: InvokeDatagridBulkActionTarget
) => {
  window.dispatchEvent(
    new CustomEvent(INVOKE_EAGRID_BULK_ACTION_EVENT, {detail: {gridCode, target}})
  );
};
